import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

export const optionShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export default function FlyoutContent({ options, onSaveChange, setIsOpen }) {
  return (
    <ul>
      {options.map((option) => (
        <li key={option.label}>
          <Button
            type="link"
            onClick={() => {
              setIsOpen(false);
              onSaveChange(option);
            }}>
            {option.label}
          </Button>
        </li>
      ))}
    </ul>
  );
}

FlyoutContent.propTypes = {
  options: PropTypes.arrayOf(optionShape),
  onSaveChange: PropTypes.func,
  setIsOpen: PropTypes.func,
};
